import React from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import messages from 'routes/App/Dashboard/translate'
import './style.scss'

function FilterSchema(props) {
  const {
    currentWeek,
    currentYear,
    currentMonth,
    isDisablePrevYear,
    isDisableNextYear,
    isDisablePrevWeek,
    isDisableNextWeek,
    prevYear,
    nextYear,
    prevWeek,
    nextWeek,
    onChronologyNavigate,
  } = props

  return (
    <div className="week-picker-filter">
      <IconButton
        data-nav="prev"
        data-nav-step="years"
        onClick={onChronologyNavigate}
        disabled={isDisablePrevYear}>
        <Tooltip title={`Go to year ${prevYear()}`}>
          <Icon>first_page</Icon>
        </Tooltip>
      </IconButton>
      <IconButton
        data-nav="prev"
        data-nav-step="weeks"
        onClick={onChronologyNavigate}
        disabled={isDisablePrevWeek}>
        <Tooltip title={`Go to week #${prevWeek(currentWeek)}`}>
          <Icon>navigate_before</Icon>
        </Tooltip>
      </IconButton>
      <div className="change-date">
        <Typography variant="subtitle2">
          <FormattedMessage {...messages.filterWeek} /> {currentWeek}
        </Typography>
        <Typography variant="caption">{`${currentMonth}, ${currentYear}`}</Typography>
      </div>
      <IconButton
        data-nav="next"
        data-nav-step="weeks"
        onClick={onChronologyNavigate}
        disabled={isDisableNextWeek}>
        <Tooltip title={`Go to week #${nextWeek(currentWeek)}`}>
          <Icon>navigate_next</Icon>
        </Tooltip>
      </IconButton>
      <IconButton
        data-nav="next"
        data-nav-step="years"
        onClick={onChronologyNavigate}
        disabled={isDisableNextYear}>
        <Tooltip title={`Go to year ${nextYear()}`}>
          <Icon>last_page</Icon>
        </Tooltip>
      </IconButton>
    </div>
  )
}

export default FilterSchema
